<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row mt-3">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <b-row>
              <b-col lg="8" class="my-1">
                <b-button v-if="modulePermission.create == 1" @click="AddBuilding()" class="btn-outline-primary" v-b-tooltip.hover title="Add New Building">
                  <b-icon class="text-center" icon="plus"></b-icon> New Building
                </b-button>
            </b-col>
             <b-col lg="4" class="my-1">
                  <b-form-group class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        placeholder="Filter"
                      ></b-form-input>

                      <b-input-group-append>
                        <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''" v-b-tooltip.hover title="Clear Filter"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            
            <template>
              <div class="table-container">
              <b-table-simple
                :small="true"
                sticky-header
                style="max-height: 395px;"
                striped
                responsive
                hover
              >
                <b-thead>
                  <b-tr>
                    <b-th>No.</b-th>
                    <b-th>Name</b-th>
                    <b-th>Location</b-th>
                    <b-th>Description</b-th>
                    <b-th v-if="userRole !== 'COLLECTOR'">Electric Bill Payment Options</b-th>
                    <b-th v-if="userRole !== 'COLLECTOR'">Water Bill Payment Options</b-th>
                    <b-th>Created At</b-th>
                    <b-th>Created By</b-th>
                    <b-th>Actions</b-th>
                  </b-tr>
                </b-thead>
                <template v-if="spinner">
                <b-tbody class="text-center">
                   <b-tr >
                       <b-td colspan="6" class="text-center" style="display: table-cell">
                        <b-spinner
                        style="height: 3rem; width: 3rem;"
                          variant="warning"
                        ></b-spinner>
                       </b-td>
                    </b-tr>
                </b-tbody>
                </template>
                <template v-else>
                  <b-tbody>
                  <template v-if="filterTable.length === 0">
                      <b-tr>
                        <b-td colspan="5" class="text-center">Nothing found</b-td>
                        <b-td>-</b-td>
                      </b-tr>
                  </template>
                  <template v-else>
                  <b-tr
                    v-for="(item, index) in filterTable"
                    :key="item.ID"
                  >
                      <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                      <b-td>{{item.buildingName}}</b-td>
                      <b-td>{{item.location}}</b-td>
                      <b-td>{{item.description}}</b-td>
                      <b-td v-if="userRole !== 'COLLECTOR'">
                          <template v-if="item.electricBillAmountOption === 'BySQM'">
                        Distribute bill with house size
                        </template>
                        <template v-if="item.electricBillAmountOption === 'EqualForAllHouse'">
                       Distribute bill equal amount
                        </template>
                          <template v-if="item.electricBillAmountOption === 'ByAmountForEachHouse'">
                       Define bill for each house
                        </template>
                          <template v-if="item.electricBillAmountOption === 'ByReading'">
                       Define bill reading for each house
                        </template>
                          <template v-if="item.electricBillAmountOption === 'none'">
                       No Bills
                        </template>
                        </b-td>
                        <b-td v-if="userRole !== 'COLLECTOR'">
                          <template v-if="item.waterBillAmountOption === 'BySQM'">
                        Distribute bill with house size
                        </template>
                        <template v-if="item.waterBillAmountOption === 'EqualForAllHouse'">
                       Distribute bill equal amount
                        </template>
                          <template v-if="item.waterBillAmountOption === 'ByAmountForEachHouse'">
                       Define bill for each house
                        </template>
                          <template v-if="item.waterBillAmountOption === 'ByReading'">
                       Define bill reading for each house
                        </template>
                          <template v-if="item.waterBillAmountOption === 'none'">
                       No Bills
                        </template>
                        </b-td>
                      <b-td>{{item.createdDate}}</b-td>
                       <b-td>{{item.registeredBy}}</b-td>
                      <b-td>
                        <b-icon v-if="modulePermission.update == 1" icon="pencil-square" class="btn-icon mr-2" @click="EditBuilding(item.buildingId)" v-b-tooltip.hover title="Edit Building"></b-icon>
                        <b-icon v-if="modulePermission.update == 1 && ((item.electricBillAmountOption == 'BySQM'||item.electricBillAmountOption == 'EqualForAllHouse')||(item.waterBillAmountOption == 'BySQM'||item.waterBillAmountOption == 'EqualForAllHouse'))" icon="currency-dollar" class="btn-icon" @click="AddBillsForBuilding(item.buildingId)" v-b-tooltip.hover title="Add Bills for Building"></b-icon>
                      </b-td>
                  </b-tr>
                  </template>
                </b-tbody>
                </template>
              </b-table-simple>
              </div>
              <div class="pagination-container mt-2">
              <b-row>
                <b-col md="3">
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols="8" label-cols-xs="8" label-size="md"
                    label="records per page"
                    label-for="input-horizontal"
                    label-align-xl="right"  
                  >
                  <b-form-select id="input-horizontal" v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="9">
                  <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" @page-click="changePage" align="right"></b-pagination>
                </b-col>
              </b-row>
              </div>
            </template>
          </card>
        </div>
      </div>
      <div class="row">
        <b-modal
            id="modal-center-add"
            hide-footer
            title="Add Building"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Add Building</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitAddForm)"
              >
                <b-row no-gutters>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addData.buildingName"
                      @update:modelValue="
                        (newValue) => (addData.buildingName = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-buildingName"
                      name="text-buildingName"
                      label="Building Name"
                      class="mb-1 mr-sm-2"
                      description="text-buildingName-feedback"
                      validatorName="Building Name"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addData.location"
                      @update:modelValue="
                        (newValue) => (addData.location = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-location"
                      name="text-location"
                      label="Location"
                      class="mb-1 mr-sm-2"
                      description="text-location-feedback"
                      validatorName="Location"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addData.description"
                      @update:modelValue="
                        (newValue) => (addData.description = newValue)
                      "
                      :rules="{}"
                      id="text-description"
                      name="text-description"
                      label="Description"
                      class="mb-1 mr-sm-2"
                      description="text-description-feedback"
                      validatorName="Description"
                    />
                  </b-col>
                  <template v-if="userRole !== 'COLLECTOR'">
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addData.billExist"
                      @update:modelValue="
                        (newValue) => (addData.billExist = newValue)
                      "
                        :options="billExistOptions"
                      :rules="{ required: true }"
                      id="text-bill-exist"
                      name="text-bill-exist"
                      label="Bill Existance"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-bill-exist-feedback"
                      validatorName="Bill Existance"
                    />
                  </b-col>
                  </template>
                  <template v-if="addData.billExist === 'yes'">
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addData.electricBillAmountOption"
                      @update:modelValue="
                        (newValue) => (addData.electricBillAmountOption = newValue)
                      "
                        :options="billAmountOptions"
                      :rules="{ required: true }"
                      id="text-bill-payment"
                      name="text-bill-payment"
                      label="Electric Bill Payment Options"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-bill-payment-feedback"
                      validatorName="Electric Bill Payment Options"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addData.waterBillAmountOption"
                      @update:modelValue="
                        (newValue) => (addData.waterBillAmountOption = newValue)
                      "
                        :options="billAmountOptions"
                      :rules="{ required: true }"
                      id="text-bill-payment"
                      name="text-bill-payment"
                      label="Water Bill Payment Options"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-bill-payment-feedback"
                      validatorName="Water Bill Payment Options"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addData.billPaymentPeriod"
                      @update:modelValue="
                        (newValue) => (addData.billPaymentPeriod = newValue)
                      "
                        :options="billPeriodOptions"
                      :rules="{ required: true }"
                      id="text-bill-payment"
                      name="text-bill-payment"
                      label="Bill Payment Period"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-bill-payment-feedback"
                      validatorName="Period of Bill Payment"
                    />
                  </b-col>
                </template>
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary" v-b-tooltip.hover title="Submit Building Information">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
      <div class="row">
        <b-modal
            id="modal-top-EditBuilding"
            hide-footer
            title="Edit Building"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Edit Building</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitEditForm)"
              >
                <b-row no-gutters>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="selectedBuilding.buildingName"
                      @update:modelValue="
                        (newValue) => (selectedBuilding.buildingName = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-buildingName"
                      name="text-buildingName"
                      label="Building Name"
                      class="mb-1 mr-sm-2"
                      description="text-buildingName-feedback"
                      validatorName="Building Name"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="selectedBuilding.location"
                      @update:modelValue="
                        (newValue) => (selectedBuilding.location = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-location"
                      name="text-location"
                      label="Location"
                      class="mb-1 mr-sm-2"
                      description="text-location-feedback"
                      validatorName="Location"
                    />
                  </b-col>
                     <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="selectedBuilding.description"
                      @update:modelValue="
                        (newValue) => (selectedBuilding.description = newValue)
                      "
                      :rules="{}"
                      id="text-description"
                      name="text-description"
                      label="Description"
                      class="mb-1 mr-sm-2"
                      description="text-description-feedback"
                      validatorName="Description"
                    />
                  </b-col>
                  <template v-if="userRole !== 'COLLECTOR'">
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="selectedBuilding.billExist"
                      @update:modelValue="
                        (newValue) => (selectedBuilding.billExist = newValue)
                      "
                        :options="billExistOptions"
                      :rules="{ required: true }"
                      id="text-bill-exist"
                      name="text-bill-exist"
                      label="Bill Existance"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-bill-exist-feedback"
                      validatorName="Bill Existance"
                    />
                  </b-col>
                  </template>
                  <template v-if="selectedBuilding.billExist === 'yes' && userRole !== 'COLLECTOR'">
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="selectedBuilding.electricBillAmountOption"
                      @update:modelValue="
                        (newValue) => (selectedBuilding.electricBillAmountOption = newValue)
                      "
                        :options="billAmountOptions"
                      :rules="{ required: true }"
                      id="text-bill-payment"
                      name="text-bill-payment"
                      label="Electric Bill Payment Options"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-bill-payment-feedback"
                      validatorName="Electric Bill Payment Options"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="selectedBuilding.waterBillAmountOption"
                      @update:modelValue="
                        (newValue) => (selectedBuilding.waterBillAmountOption = newValue)
                      "
                        :options="billAmountOptions"
                      :rules="{ required: true }"
                      id="text-bill-payment"
                      name="text-bill-payment"
                      label="Water Bill Payment Options"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-bill-payment-feedback"
                      validatorName="Water Bill Payment Options"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="selectedBuilding.billPaymentPeriod"
                      @update:modelValue="
                        (newValue) => (selectedBuilding.billPaymentPeriod = newValue)
                      "
                        :options="billPeriodOptions"
                      :rules="{ required: true }"
                      id="text-bill-payment"
                      name="text-bill-payment"
                      label="Period of Bill Payment"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-bill-payment-feedback"
                      validatorName="Period of Bill Payment"
                    />
                  </b-col>
                </template>
                  <!-- <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="selectedBuilding.billAmountOption"
                      @update:modelValue="
                        (newValue) => (selectedBuilding.billAmountOption = newValue)
                      "
                        :options="billAmountOptions"
                      :rules="{ required: true }"
                      id="text-bill-payment"
                      name="text-bill-payment"
                      label="Bill Payment Options"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-bill-payment-feedback"
                      validatorName="Bill Payment Options"
                    />
                  </b-col> -->
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
       <div class="row" >
        <b-modal
            id="modal-top-AddBillsForBuilding"
            hide-footer
            title="Add Bills"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Add Bills</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form 
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitChangeBillForm)"
              >
                <b-row no-gutters >
                    <template v-if="addBillData.electricBillAmountOption === 'BySQM' || addBillData.electricBillAmountOption === 'EqualForAllHouse'">
                    <b-col md="12" style="justify-content: center; align-items: center">
                      <VinputNumber
                        inputType="number"
                        :modelValue="addBillData.electricPrice"
                        @update:modelValue="billElectric"
                        :rules="{ required: true }"
                        id="text-electric-price"
                        name="text-electric-price"
                        label="Electric Bill"
                        class="mb-1 mr-sm-2"
                        description="text-electric-price-feedback"
                        validatorName="Electric Bill"
                        :step=".01"
                        @input = "handleInput"
                      />
                        <div v-if="errorMessage" class="error-message">
                        {{errorMessage}}
                        </div>
                    </b-col>
                  </template>
                  <!-- Water Bill Input -->
                  <template v-if="addBillData.waterBillAmountOption === 'BySQM' || addBillData.waterBillAmountOption === 'EqualForAllHouse'">
                    <b-col md="12" style="justify-content: center; align-items: center">
                      <VinputNumber
                        inputType="number"
                        :modelValue="addBillData.waterPrice"
                        @update:modelValue="billWater"
                        :rules="{ required: true }"
                        id="text-water-price"
                        name="text-water-price"
                        label="Water Bill"
                        class="mb-1 mr-sm-2"
                        description="text-water-price-feedback"
                        validatorName="Water Bill"
                        :step=".01"
                        @input = "handleInput"
                        :min="0"
                      />
                        <div v-if="errorMessage" class="error-message">
                        {{errorMessage}}
                        </div>
                    </b-col>
                  </template>
                    <b-col
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                        <Vinput
                          inputType="date"
                          :modelValue="addBillData.startDate"
                          @update:modelValue="
                            (newValue) => (addBillData.startDate = newValue)
                          "
                          :rules="{ required: true }"
                          id="text-startDate"
                          name="text-startDate"
                          label="Start Bill on"
                          class="mb-1 mr-sm-2"
                          description="text-startDate-feedback"
                          validatorName="Start Bill on"
                        />
                    </b-col>
                     <b-col class="mt-2">
                    <b-button type="submit" variant="primary" v-b-tooltip.hover title="Submit Bills Information">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import Vinput from 'src/components/Inputs/Vinput.vue'
  import Vselect from 'src/components/Inputs/Vselect.vue'
  import VinputNumber from 'src/components/Inputs/VinputNumber.vue'
  export default {
    components: {
      LTable,
      Card,
      Vinput,
      Vselect,
      VinputNumber
    },
    data () {
      return {
      electricPrice: 0,
      buildings: [],
      buildingOptions: [],
      buildingDetails: {},
        modulePermission: {
          view: 1,
          create: 0,
          update: 0,
          delete: 0
        },
        totalRows: 0,
        currentPage: 1,
        perPage: 7,
        pageOptions: [
          {value: 7, text: 7},
          {value: 10, text: 10},
          {value: 25, text: 25},
          {value: 50, text: 50},
          {value: 100, text: 100}
        ],
        items: [],
        filter: "",
        addData: {
          buildingId:null,
          buildingName:"",
          location:"",
          description:"",
          billExist:"",
          electricBillAmountOption: "",
          waterBillAmountOption:"",
          billPaymentPeriod:null,
          priceOption: "",
          electricPrice: null,
          waterPrice: null,
          parkingPrice: null,
          internetPrice: null,
          otherPrice: null,
          billStartsOn:"",
          user: {
            id: sessionStorage.getItem("ID")
          },
          registeredBy: sessionStorage.getItem("userID")
        },
        addBillData:{
          billExist:"",
          electricBillAmountOption: "",
          billStartsOn: "",
          waterBillAmountOption:"",
          billPaymentPeriod:null,
          electricPrice: 0.0,
          waterPrice: 0.0,
          startDate: null,
        },
        billAmountOptions: [
          {text: "----- Please select bill options ----", value:null },
          {text: "No bills", value: "none"},
          {text: "Distribute bill with house size", value: "BySQM"},
          {text: "Distribute with equal amount", value: "EqualForAllHouse"},
          {text: "Define bill for each house", value: "ByAmountForEachHouse"},
          {text: "Define bill reading for each house", value: "ByReading"}
        ],
        billExistOptions: [
          // {text: "----- Please select bill exist or not ----", value:null },
          {text: "No", value: "no"},
          {text: "Yes", value: "yes"}
        ],
        billPeriodOptions: [
          // {text: "----- Please select bill exist or not ----", value:null },
          {text: "1 Month", value: "1"},
          {text: "2 Month", value: "2"},
          {text: "3 Month", value: "3"},
          {text: "4 Month", value: "4"},
          {text: "5 Month", value: "5"},
          {text: "6 Month", value: "6"},
        ],
        selectedBuilding: {
          buildingId: null,
          id: null,
          createdBy: parseInt(sessionStorage.getItem('userID')) || null,
          buildingName: "",
          location: "",
          description: "",
          status: null,
          billExist: "",
          electricBillAmountOption: "",
          waterBillAmountOption: "",
          billPaymentPeriod: null
        },
        spinner: true
      }
    },
    computed: {
      userRole() {
        return sessionStorage.getItem('userRole');
      },
      filterTable() {
        var searchItems = this.items;
        var searchString = this.filter;
        if (searchString === "") {
          return searchItems;
        }
        searchString = searchString.trim().toLowerCase();

        searchItems = searchItems.filter(function (item) {
          if (item.buildingName.toLowerCase().indexOf(searchString) !== -1 || item.location.toLowerCase().indexOf(searchString) !== -1) {
            return item;
          }
        });
        return searchItems;
      },
    },
     mounted() {
      this.getModules();
      this.getBuildingsByOwnerID();
      this.$on("AfterComplete", () => {
        this.getBuildingsByOwnerID();
      });
    },
    methods: {
      billElectric(newValue){
        this.addBillData.electricPrice = newValue;
        this.validateElectricAmount(newValue);
      },
      validateElectricAmount(value){
        if(value === null || value===undefined || isNaN(value)){
          this.errorMessage = '';
        }
        else if(value< 0){
          this.errorMessage = 'Amount must be greater than zero';
        }
        else{
          this.errorMessage = '';
        }
      },
      billWater(newValue){
        this.addBillData.waterPrice = newValue;
        this.validateWaterAmount(newValue);
      },
      validateWaterAmount(value){
        if(value === null || value===undefined || isNaN(value)){
          this.errorMessage1 = '';
        }
        else if(value< 0){
          this.errorMessage1 = 'Amount must be greater than zero';
        }
        else{
          this.errorMessage1 = '';
        }
      },
      handleInput(event){
        let value = parseFloat(event.target.value);
        if(isNaN(value)||value<0){
          value=0;
        }
        this.addBillData.electricPrice = value;
        this.addBillData.waterPrice = value;
      },
      getModules(){
        this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
          .then(response=>{
              //this.items = response.data;
              var modulesList = response.data.modules;
              var BuildingModule = modulesList.filter(x=>x.name === "Building");
              if(BuildingModule !== null){
                this.modulePermission.view = BuildingModule[0].listData;
                this.modulePermission.create = BuildingModule[0].createData;
                this.modulePermission.update = BuildingModule[0].updateData;
                this.modulePermission.delete = BuildingModule[0].deleteData;
              }
          })
          .catch(error=>{
              console.log(error);
          })
      },
      getBuildingsByOwnerID(){
          this.$store.dispatch('getBuildingsByOwnerID', {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage})
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
      },
      changePage(event, page){
        this.spinner = true;
        this.$store.dispatch('getBuildingsByOwnerID', {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage})
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
      },
      changePerPage(event){
        this.spinner = true;
        this.$store.dispatch('getBuildingsByOwnerID', {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage})
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
      },
      AddBillsForBuilding(ID) {
    this.selectedBuilding.buildingId = ID;
    // Dispatch the Vuex action to fetch data
    this.$store.dispatch('getOneBuildingsByID', { buildingId: ID })
      .then(response => {
        // Ensure response.data is not undefined or empty
        // if (response && response.data && response.data.length > 0) {
        console.log("response", response);
          this.addBillData.electricPrice = response.data.electricPrice;
          this.addBillData.waterPrice = response.data.waterPrice;
          this.addBillData.electricBillAmountOption = response.data.electricBillAmountOption;
          this.addBillData.waterBillAmountOption = response.data.waterBillAmountOption;
          this.addBillData.billPaymentPeriod = response.data.billPaymentPeriod;
          this.addBillData.billExist = response.data.billExist;
          this.addBillData.billStartsOn = response.data.billStartsOn;
          this.addBillData.startDate = response.data.billStartsOn;
          this.$bvModal.show('modal-top-AddBillsForBuilding');
        // } else {
        //   console.error('No building data found.');
        // }
      })
      .catch(error => {
        this.$notify({
          title: 'Error',
          text: (error.response && error.response.data) || 'An unexpected error occurred',
          type: 'error'
        });
        console.error('Error fetching building data:', error);
      });
  },
      submitChangeBillForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to change bills ?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
        .then(value => {
            if(value === true){
              // Build payload according to backend BuildingBillAmountDto
              const payload = {
                createdBy: parseInt(sessionStorage.getItem('userID')),
                buildingId: this.selectedBuilding.buildingId,
                userId: parseInt(sessionStorage.getItem('ID')),
                startDate: this.addBillData.startDate
              };

              // Only include electric/water amounts when the building's bill option requires it
              if (this.addBillData.electricBillAmountOption === 'BySQM' || this.addBillData.electricBillAmountOption === 'EqualForAllHouse') {
                payload.electricBill = parseFloat(this.addBillData.electricPrice) || 0;
              }
              if (this.addBillData.waterBillAmountOption === 'BySQM' || this.addBillData.waterBillAmountOption === 'EqualForAllHouse') {
                payload.waterBill = parseFloat(this.addBillData.waterPrice) || 0;
              }

              this.$store.dispatch('AddBillsForBuilding', payload)
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `Bills Successfully Updated.`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    })
                    this.$bvModal.hide('modal-top-AddBillsForBuilding');
                    this.$bvModal.hide('modal-top-changePrice');
                    this.clearData();
                    // Refresh buildings and notify other components
                    this.getBuildingsByOwnerID();
                    this.$emit('AfterComplete');
              })
              .catch(error=>{
                this.$notifications.notify(
                    {
                      message: error.response.data,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                    })
                  console.log(error);
              })
            }
        })
        .catch(error=>{
            console.log(error)
        })
      },
      AddBuilding(){
        this.$bvModal.show('modal-center-add');
      },
      submitAddForm(){
            this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
                 title: 'Confirm',
                 size: 'sm',
                 buttonSize: 'sm',
                 okVariant: 'success',
                 cancelVariant: 'danger',
                 okTitle: 'YES',
                 cancelTitle: 'NO',
                 bodyClass: 'm-2',
                 hideHeaderClose: false,
                 centered: false
             })
             .then(value => {
                 if(value === true){
                    this.$store.dispatch('AddBuilding', this.addData)
                    .then(response=>{
                        this.$notifications.notify(
                          {
                            message: `Building successfully created.`,
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            type: 'success'
                          })
                          this.$bvModal.hide('modal-center-add');
                          this.clearData();
                    })
                    .catch(error=>{
                       this.$notifications.notify(
                          {
                            message: error.response.data,
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            type: 'danger'
                          })
                        console.log(error);
                    })
                 }
             })
             .catch(error=>{
                  console.log(error)
             })
      },
      EditBuilding(ID){
        var Building= this.items.filter(item=> item.buildingId == ID)[0];
        this.selectedBuilding.id = Building.buildingId;
        this.selectedBuilding.buildingId = Building.buildingId;
        this.selectedBuilding.createdBy = parseInt(sessionStorage.getItem('userID')) || null;
        this.selectedBuilding.buildingName = Building.buildingName;
        this.selectedBuilding.location = Building.location;
        this.selectedBuilding.description = Building.description;
        this.selectedBuilding.status = Building.status || null;
        this.selectedBuilding.billExist = Building.billExist;
        this.selectedBuilding.electricBillAmountOption = Building.electricBillAmountOption;
        this.selectedBuilding.waterBillAmountOption = Building.waterBillAmountOption;
        this.selectedBuilding.billPaymentPeriod = Building.billPaymentPeriod;
        this.selectedBuilding.billStartsOn = Building.billStartsOn;
        this.$bvModal.show('modal-top-EditBuilding');
      },
      submitEditForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
            title: 'Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            cancelVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            bodyClass: 'm-2',
            hideHeaderClose: false,
            centered: false
        })
        .then(value => {
            if(value === true){
              const payload = {
                id: this.selectedBuilding.id || this.selectedBuilding.buildingId,
                createdBy: this.selectedBuilding.createdBy || parseInt(sessionStorage.getItem('userID')) || null,
                buildingName: this.selectedBuilding.buildingName,
                location: this.selectedBuilding.location,
                description: this.selectedBuilding.description,
                status: this.selectedBuilding.status,
                billExist: this.selectedBuilding.billExist,
                electricBillAmountOption: this.selectedBuilding.billExist === 'no' ? 'none' : this.selectedBuilding.electricBillAmountOption,
                waterBillAmountOption: this.selectedBuilding.billExist === 'no' ? 'none' : this.selectedBuilding.waterBillAmountOption,
                billPaymentPeriod: this.selectedBuilding.billExist === 'no' ? 0 : parseInt(this.selectedBuilding.billPaymentPeriod) || 0
              };

              if (payload.billExist === 'no') {
                this.selectedBuilding.electricBillAmountOption = 'none';
                this.selectedBuilding.waterBillAmountOption = 'none';
                this.selectedBuilding.billPaymentPeriod = 0;
              }

              this.$store.dispatch('EditBuilding', payload)
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `Building Successfully Updated.`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    })
                    this.$bvModal.hide('modal-top-EditBuilding');
                    this.clearData();
              })
              .catch(error=>{
                console.log(error);
                this.$notifications.notify(
                    {
                      message: (error.response && error.response.data) || 'An error occurred while updating the building.',
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                    })
                  console.log(error);
              })
            }
        })
        .catch(error=>{
            console.log(error)
        })
      },
      clearData(){
        this.addData.buildingName = "";
        this.addData.location = "";
        this.addData.description = "";
        this.addData.waterBillAmountOption = "";
        this.addData.electricBillAmountOption = "";
        this.addData.billPaymentPeriod = "";
        this.addData.billExist = "";
        this.addData.billStartsOn = "";
        this.selectedBuilding = {};
        this.addBillData.electricPrice = this.addBillData.waterPrice = this.addBillData.startDate =  null;
        this.$emit('AfterComplete');
      }
    },
  }
</script>

<style scoped>
.table-container {
  overflow-x: auto;
}
.pagination-container {
  border-top: 1px solid #dee2e6;
  padding-top: 8px;
  background: #fff;
  position: relative;
  z-index: 1;
}
.btn-icon {
  font-size: 24px;
  cursor: pointer;
  color: rgb(37, 91, 48);
}
.btn-icon:hover {
  color: rgba(240, 206, 13, 0.937);
}
</style>
<style scoped>
.error-message {
  color: rgb(219, 63, 63);
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
.b-table-sticky-column:last-child {
  right: 0;
}
.text-warning {
    color: rgba(240, 206, 13, 0.937) !important;
}
.btn-icon {
  font-size: 24px;
  cursor: pointer;
  color: rgb(37, 91, 48);
}
.btn-icon:hover {
  color: rgba(240, 206, 13, 0.937);
}
</style>
